var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6795 7.49917L15.8337 7.5C16.2937 7.5 16.667 7.87334 16.667 8.33417C16.6662 8.79417 16.2929 9.16667 15.8337 9.16667H15.8329L11.687 9.16417C11.2287 9.16417 10.8562 8.79334 10.8537 8.335L10.8337 4.17084C10.8312 3.71084 11.202 3.33584 11.6629 3.33334H11.667C12.1254 3.33334 12.4979 3.70334 12.5004 4.1625L12.5104 6.31084L15.2437 3.5775C15.5695 3.25167 16.097 3.25167 16.4229 3.5775C16.7479 3.90334 16.7479 4.43 16.4229 4.75584L13.6795 7.49917ZM4.17037 10.8337L8.33454 10.8545C8.79287 10.857 9.1637 11.2287 9.1637 11.687L9.16704 15.8328C9.16704 16.2928 8.7937 16.667 8.3337 16.667C7.87287 16.667 7.50037 16.2937 7.50037 15.8345L7.4987 13.6803L4.7562 16.4228C4.59287 16.5853 4.37954 16.667 4.16704 16.667C3.9537 16.667 3.74037 16.5853 3.57787 16.4228C3.25204 16.097 3.25204 15.5695 3.57787 15.2445L6.31037 12.5112L4.16287 12.5003C3.70204 12.4978 3.3312 12.122 3.3337 11.6628C3.33537 11.2037 3.7087 10.8337 4.16704 10.8337H4.17037Z",
    fill: "#8D96B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/ZoomOut.50a19f8ba9d13fdd1c6ccf04fa79ea31.svg";
export { ForwardRef as ReactComponent };